import styles from '../styles/shopPage.module.scss'

const ShopPage = () => {
  return (
    <div className={styles.Page}>
      <div className="container">
        <div className={styles.Info}>
          <h1>Благотворительный магазин</h1>
          <p>
          <span>Поддержка DonorSearch через покупку сувениров и одежды с донорской символикой!</span><br />
            Приобретение мерча — это не просто покупка, а реальная поддержка DonorSearch и популяризация донорства.<br />
            Все вырученные средства направляются на нашу уставную деятельность, что помогает нам продолжать делать мир лучше.<br /><br />
            Мы поддерживаем доноров различными бесплатными сувенирами и мерчем а рамках акций и грантовых проектов по мере возможности нашего<br />
            ограниченного бюджета. Однако, у вас есть прекрасный шанс получить стильные вещи и одновременно поддержать наш проект.<br />
            Вы можете приобрести наш мерч на различных маркетплейсах, где каждый найдет что-то по душе.<br />
            На страницах ниже представлены ссылки на магазины, где доступен наш мерч.<br />
            Выручка идет на уставную деятельность нашей некоммерческой организации.
          </p>
        </div>

        <div className={styles.ShopBlock}>
          <h2>Выберите один из магазинов</h2>
          <div className={styles.ShopBlock_list}>
            <a href="https://market.yandex.ru/business--donorsearch-shop-magazin-soobshchestva-donorov/123729115/?utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.ShopBlock_list__card}>
              <img src="/static/images/shop/yaMarket.svg" alt="" />
            </a>
            <a href="https://amorem.ru/catalog/kollektsii/kod_svyazi_/?utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.ShopBlock_list__card}>
              <img src="/static/images/shop/amorem-logo.png" alt="" className={styles.AmoremLogo}/>
            </a>
            <a href="https://www.ozon.ru/seller/donorsearch-2545095/products/?miniapp=seller_2545095&utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.ShopBlock_list__card}>
              <img src="/static/images/shop/ozon.svg" alt="" />
            </a>
            <a href="https://donorsearch.vsemaykishop.ru?utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.ShopBlock_list__card}>
              <img src="/static/images/shop/vseMayki.svg" alt="" />
            </a>
            <a href="https://gen.ru/collection/donor-search?utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.ShopBlock_list__card}>
              <img src="/static/images/shop/genStore.svg" alt="" />
            </a>
          </div>

          <div className={styles.ShopBlock_preview}>
            <div className={styles.ShopBlock_preview__images}>
              <a href="https://market.yandex.ru/business--donorsearch-shop-magazin-soobshchestva-donorov/123729115/?utm_source=shop&utm_medium=ds&utm_campaign=donor_search">
                <img src="/static/images/shop/previewShop1.jpeg" alt="" />
              </a>
              <a href="https://amorem.ru/catalog/kollektsii/kod_svyazi_/?utm_source=shop&utm_medium=ds&utm_campaign=donor_search" className={styles.Amorem}>
                <img src="/static/images/shop/amorem-preview.png" alt="" />
              </a>
              <a href="https://www.ozon.ru/seller/donorsearch-2545095/products/?miniapp=seller_2545095&utm_source=shop&utm_medium=ds&utm_campaign=donor_search">
                <img src="/static/images/shop/previewShop4.jpg" alt="" />
              </a>
              <a href="https://donorsearch.vsemaykishop.ru?utm_source=shop&utm_medium=ds&utm_campaign=donor_search">
                <img src="/static/images/shop/previewShop3.png" alt="" />
              </a>
              <a href="https://gen.ru/collection/donor-search?utm_source=shop&utm_medium=ds&utm_campaign=donor_search">
                <img src="/static/images/shop/previewShop2.png" alt="" />
              </a>
            </div>
            <p>Примеры ассортимента в разных магазинах, актуальный ассортимент и цены товаров смотрите по ссылкам.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPage;